import React, { useState, useEffect } from "react";
import { Alert, Button, Space } from "antd";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Alert
      className="vm__show_cookies"
      message="We use Cookies"
      description="This Application uses cookies to ensure you get the best experience. By using this application, you agree to our use of cookies."
      type="info"
      action={
        <Space direction="horizontal">
          <Button size="small" type="primary" onClick={handleAccept}>
            Accept
          </Button>
          <Button size="small" danger ghost onClick={handleDecline}>
            Decline
          </Button>
        </Space>
      }
      closable={false}
      onClose={() => setVisible(false)}
    />
  );
};

export default CookieConsent;
